<!-- 音频播放预览-弹框组件 -->
<template>
  <a-modal
    v-model="visible"
    :title="title"
    :dialogStyle="{ top: '30vh' }"
    :width="350"
    :maskClosable="false"
    :afterClose="afterClose"
  >
    <a-spin :spinning="loading">
      <div class="modal_content">
        <audio
          v-if="audioUrl"
          ref="audioRef"
          class="audio"
          controls
          preload="metadata"
          :src="audioUrl"
          @error="onError"
        />
      </div>
    </a-spin>
    <template #footer>
      <a-button @click="close">关闭</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'playAudioModal',
  emits: ['afterClose'],
  props: {
    autoplay: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '音频播放'
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      audioUrl: ''
    }
  },

  methods: {
    /**
     * 播放视频
     */
    play() {
      if (this.audioUrl) {
        this.$refs.audioRef && this.$refs.audioRef.play()
      } else {
        throw new Error('play error: audioUrl is empty')
      }
    },

    /**
     * 暂停视频
     */
    pause() {
      if (this.audioUrl) {
        this.$refs.audioRef && this.$refs.audioRef.pause()
      } else {
        throw new Error('pause error: audioUrl is empty')
      }
    },

    onError(err) {
      console.error('video play error:', err)
      this.$message.error('视频播放失败')
    },

    /**
     * 重置数据
     */
    afterClose() {
      this.loading = false
      this.audioUrl = ''
      this.$emit('afterClose')
    },

    /**
     * 打开弹窗
     */
    open(url) {
      if (this.visible) return
      this.visible = true
      this.audioUrl = url
      if (this.autoplay) {
        this.$nextTick(() => {
          this.play()
        })
      }
    },

    /**
     * 关闭弹窗
     */
    close() {
      if (!this.visible) return
      this.visible = false
    }
  },

  mounted() {},

  beforeDestroy() {}
}
</script>

<style lang="scss" scoped>
.modal_content {
  width: 100%;
  height: 60px;
  text-align: center;
}
</style>
